(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["linea"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  try {
    var sections = document.querySelectorAll('.linea-observable');
    if (!('IntersectionObserver' in window) || !sections.length) {
      // Sin IO: mostrar la línea sin animación para compatibilidad
      sections.forEach(function(s){ s.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target); // animar una sola vez
        }
      });
    }, { threshold: 0.2 });
    sections.forEach(function(s){ io.observe(s); });
  } catch(e) { /* fallback silencioso */ }
});

  } catch(e) { console.error(e); }
})();
})();
